import React from 'react';
import EditButton from 'components/RestActions/EditButton';
import { useHistory } from 'react-router';
import { ENQUIRIES_STATUS_CONST, PERMISSION_KEY } from 'configs/localData';
import { ActionsStyles } from '../styles';

interface Props {
  id?: string;
  centreEnquiryStatus?: string;
  packageName?: string;
  centreId?: string;
}

const GroupActionEnquiry = ({
  id,
  centreEnquiryStatus,
  packageName,
  centreId,
}: Props) => {
  const { push } = useHistory();

  const handleRedirect = () => {
    centreEnquiryStatus === ENQUIRIES_STATUS_CONST.archived.value
      ? push(`/enquiries/archived/${id}`)
      : push(`/enquiries/all/${id}`);
  };
  return (
    <ActionsStyles>
      <EditButton
        permissionKey={PERMISSION_KEY.contacts}
        action="isView"
        packageName={packageName}
        isView
        onClickCustom={handleRedirect}
        centreId={centreId}
      />
    </ActionsStyles>
  );
};

export default GroupActionEnquiry;
